import React, { useState, useEffect } from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import { Link, useLocation, useHistory } from "react-router-dom";
import { MDBListGroupItem } from "mdb-react-ui-kit";
import axios from "axios";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Box from "@mui/material/Box";
import "./Sidbarbusiness.css";

import logo from "../../../images/business dashboard/logo-light.png";
// imgages when active page
import DashboardImg from "../../../images/business dashboard/category.png";
import InformationImg from "../../../images/business dashboard/information.png";
import CommentImg from "../../../images/business dashboard/comment.png";
import MessageImg from "../../../images/business dashboard/send (1).png";
import AddPicImg from "../../../images/business dashboard/add pic.png";
import AmarImg from "../../../images/business dashboard/آمار و گذارشات.png";
import TablighatImg from "../../../images/business dashboard/loud-speaker.png";
import SettingImg from "../../../images/business dashboard/setting.png";
import LogoutImg from "../../../images/business dashboard/log-out.png";

import Dashboard from "../../../images/business dashboard/category gray.png";
import Information from "../../../images/business dashboard/information gray.png";
import Comment from "../../../images/business dashboard/comment gray.png";
import Message from "../../../images/business dashboard/send gray.png";
import AddPic from "../../../images/business dashboard/add pic gray.png";
import Amar from "../../../images/business dashboard/آمار و گذارشات gray.png";
import Tablighat from "../../../images/business dashboard/loud-speaker gray.png";
import Setting from "../../../images/business dashboard/setting gray.png";
import Logout from "../../../images/business dashboard/log-out gray.png";

import AddIcon from "../../../images/business dashboard/white-add.png";
import NextIcon from "../../../images/business dashboard/next white.png";
import TikIcon from "../../../images/business dashboard/Tik.png";
import AddIconBlue from "../../../images/business dashboard/blue-add.png";

// config
import configData from "../../../config/config.json";

const Sidbar = (props) => {
  const location = useLocation().pathname;

  const [showmenuBiz, setshowmenuBiz] = useState(false);
  const handleShowBiz = () => {
    setshowmenuBiz((prevState) => !prevState);
  };
  const handleShowAwayBiz = () => {
    setshowmenuBiz(false);
  };

  const [bizList, setBizList] = useState([]);
  const { setHasDescription, setRender } = props;

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Authorization: "Bearer " + getCookie("token"),
  };

  const history = useHistory();

  useEffect(() => {
    // let OwnerIdCookie = getCookie("OwnerId");
    // if (!OwnerIdCookie) {
    //   props.history.push({
    //     pathname: "/login",
    //   });
    // } else {

    // mina nadare
    // axios
    //   .get(domain + "/api/biz/register/check-complete", {
    //     headers: {
    //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    //       LangId: 1,
    //       OwnerId: getCookie("OwnerId"),
    //       BizId: getCookie("BizId"),
    //     },
    //   })
    //   .then((response) => {
    //     if (response.data.msg == "not-registered") {
    //       history.push({
    //         pathname: "/signup",
    //       });
    //     } else if (response.data.msg == "done") {
    //       if (!response.data.IsComplete) {
    //         history.push({
    //           pathname: "/register-business-step1",
    //         });
    //       } else {
    axios
      .get(configData.API_DOMAIN + "/api/v1/Businesses", {
        headers: header,
      })
      .then((response) => {
        if (response.data.isSuccess) {
          setRender(true);
          const completeList = response.data.data.filter(
            (element) => element.isComplete
          );
          setCookie("OwnerBizNumber", completeList.length, 1);

          if (response.data.data.length > 0) {
            let foundBiz = response.data.data.find(
              (element) => element.bId == getCookie("BizId")
            );

            if (!foundBiz) {
              foundBiz = response.data.data[0];
              setCookie("BizId", foundBiz.bId, 1);
              setCookie("BizUuid", foundBiz.id, 1);
            }

            if (!foundBiz.isComplete) {
              history.push({
                pathname: "/register-business-step1",
              });
            } else {
              setBizList(response.data.data);

              if (setHasDescription) {
                setHasDescription(foundBiz.hasDescription);
              }
            }
          } else {
            newBizHandler();
          }
        }
      })
      .catch((error) => {
        // alert(error);
      });
    //     }
    //   }
    // })
    // .catch((error) => {
    //   // alert(error);
    // });
    // }
  }, []);

  const [centredModal, setCentredModal] = useState(false);
  const toggleShow = () => setCentredModal(!centredModal);

  const bizChangeHandler = (bizId, bizUuid) => {
    setCookie("BizId", bizId, 1);
    setCookie("BizUuid", bizUuid, 1);
    window.location.reload();
  };

  const newBizHandler = () => {
    const newList = bizList.filter(
      (element) =>
        !element.isApproved || (element.isApproved && !element.isDisable)
    );

    if (newList.length >= 4) {
      // need-premium-account
      setshowmenuBiz(false);
      setCentredModal(true);
    } else {
      axios
        .post(
          configData.API_DOMAIN + "/api/v1/Businesses/new",
          {},
          {
            headers: {
              ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
              LangId: 1,
              Authorization: "Bearer " + getCookie("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess) {
            let data = response.data.data;
            setCookie("BizId", data.bId, 1);
            setCookie("BizUuid", data.id, 1);
            eraseCookie("CatIds");
            eraseCookie("CatId");

            if (data.regStep === 0) {
              history.push({
                pathname: "/register-business-step1",
              });
            } else {
              history.push({
                pathname: `/register-business-step${data.regStep}`,
              });
            }
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
    // new biz api by aidin
    // axios
    //   .get(domain + "/api/biz/register/add-new-business", {
    //     headers: {
    //       ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    //       LangId: 1,
    //       OwnerId: getCookie("OwnerId"),
    //     },
    //   })
    //   .then((response) => {
    //     if (response.data.msg == "not-registered") {
    //       history.push({
    //         pathname: "/signup",
    //       });
    //     } else if (response.data.msg == "done") {
    //       setCookie("BizId", "ZhcM4Iy856AtH5/CoecNRw==", 1);
    //       eraseCookie("CatIds");
    //       eraseCookie("CatId");

    //       if (response.data.RegStep == 0) {
    //         history.push({
    //           pathname: "/register-business-step1",
    //         });
    //       } else {
    //         history.push({
    //           pathname: `/register-business-step${response.data.RegStep}`,
    //         });
    //       }
    //     } else if (response.data.msg == "need-premium-account") {
    //       setshowmenuBiz(false);
    //       setCentredModal(true);
    //     }
    //   })
    //   .catch((error) => {
    //     // alert(error);
    //   });
  };

  //   setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      // " domain=en-biz.gishniz.app; path=/";
      " domain=en-biz.gishniz.com; path=/";
  }
  //   eraseCookie
  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
    document.cookie =
      name +
      // "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=en-biz.gishniz.app; path=/";
      "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=en-biz.gishniz.com; path=/";
  }
  //   get cookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  return (
    <div className="h-100">
      <div className="business_dashbord">
        <div className="container_sidbar_business">
          <div className="text-align-last-right">
            <Link to="/">
              <img src={logo} alt="logoGishniz" className="img-sidbar-logo" />
            </Link>
          </div>
          <div className="dashboard-business-name">
            {bizList.length > 0 &&
              bizList.map((item) =>
                item.bId == getCookie("BizId") ? (
                  <a
                    key={item.id}
                    className={
                      item.isApprovedBusiness
                        ? "dashboard-business-link dashboard-business-link-hover"
                        : "dashboard-business-link"
                    }
                    href={item.isApprovedBusiness && item.bizUrl}
                    target="_blank"
                  >
                    <p className="mb-2">
                      {item.title ? item.title : item.enTitle}
                    </p>
                    <div className="dbiz-list-biz-text-first font-family-en">
                      {item.address}
                      {item.address && item.address !== "" && ", "}
                      {item.provinceTitle}
                      {item.provinceTitle && item.provinceTitle !== "" && ", "}
                      {item.cityTitle}
                      <br />
                      {item.countryTitle}
                    </div>
                  </a>
                ) : (
                  ""
                )
              )}
            {bizList.length < 2 ? (
              <>
                <a
                  className=" dashboard-business-add"
                  // href="/register-business-step1"
                  onClick={newBizHandler}
                >
                  <img
                    src={AddIcon}
                    alt={"+"}
                    className={"dashboard-business-add-icon"}
                  />
                  اضافه کردن کسب‌وکار
                </a>
                <hr className="dbiz-list-biz-hr" />
              </>
            ) : (
              <ClickAwayListener onClickAway={handleShowAwayBiz}>
                <Box className="position-relative">
                  <>
                    <div
                      className={
                        showmenuBiz
                          ? "select_login_head_biz"
                          : "select_login_head_biz"
                      }
                      onClick={handleShowBiz}
                    >
                      <a className="align-items-center  ">
                        <p className="mb-0 ps-2">
                          کسب‌وکارهای من (
                          {bizList.length > 0 ? bizList.length : "0"})
                        </p>
                      </a>
                      <img
                        onClick={handleShowBiz}
                        className={
                          showmenuBiz
                            ? "next-biz nextLogin-rotate-biz"
                            : "next-biz nextLogin-rotateback-biz"
                        }
                        src={NextIcon}
                        alt=""
                      ></img>
                    </div>
                    <hr className="dbiz-list-biz-hr" />

                    {showmenuBiz && (
                      <List
                        className="box_show_info_userlogin_biz"
                        component="nav"
                        aria-label="mailbox folders"
                      >
                        <p className="dashboard-business-list-tit">
                          کسب‌وکارها
                        </p>
                        <hr />
                        {bizList.length > 0 &&
                          bizList.map((item) => (
                            <a
                              onClick={() =>
                                bizChangeHandler(item.bId, item.id)
                              }
                              key={item.bId}
                            >
                              <ListItem button>
                                <div className="dbiz-list-biz-tit">
                                  {item.title ? item.title : item.enTitle}
                                  {item.bId == getCookie("BizId") ? (
                                    <img src={TikIcon} alt="done" />
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="dbiz-list-biz-text font-family-en">
                                  {item.address}
                                  {item.address && item.address !== "" && ", "}
                                  {item.provinceTitle}
                                  {item.provinceTitle &&
                                    item.provinceTitle !== "" &&
                                    ", "}
                                  {item.cityTitle}
                                </div>
                                <div className="dbiz-list-biz-text font-family-en">
                                  {item.countryTitle}
                                </div>
                              </ListItem>
                              <Divider />
                            </a>
                          ))}
                        <a
                          className=" dashboard-business-add2"
                          // href="/register-business-step1"
                          onClick={newBizHandler}
                        >
                          <img
                            src={AddIconBlue}
                            alt={"+"}
                            className={"dashboard-business-add-icon"}
                          />
                          اضافه کردن کسب‌وکار
                        </a>
                      </List>
                    )}
                  </>
                </Box>
              </ClickAwayListener>
            )}
          </div>
          <div className="dashboard_img_business">
            <div className="d-flex">
              {location == "/business-dashboard" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-dashboard"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-dashboard"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-dashboard" ? (
                    <img
                      src={DashboardImg}
                      alt="DashboardImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Dashboard}
                      alt={"user"}
                      className={"img_slider_false"}
                    />
                  )}
                  داشبورد
                </MDBListGroupItem>
              </Link>
            </div>
          </div>
          <div className="">
            <div className="d-flex">
              {location == "/business-information" && (
                <div className="active_item_business"></div>
              )}
              <Link
                className="dash-bus-sidbar-link"
                to={"/business-information"}
              >
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-information"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-information" ? (
                    <img
                      src={InformationImg}
                      alt="InformationImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Information}
                      alt={"Information"}
                      className={"img_slider_false"}
                    />
                  )}
                  اطلاعات کسب‌و‌کار
                </MDBListGroupItem>
              </Link>
            </div>
            <div className="d-flex">
              {location == "/business-reviews" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-reviews"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-reviews"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {" "}
                  {location === "/business-reviews" ? (
                    <img
                      src={CommentImg}
                      alt="Comment"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Comment}
                      alt={"Comment"}
                      className={"img_slider_false"}
                    />
                  )}
                  دیدگاه‌ها
                </MDBListGroupItem>
              </Link>
            </div>
            {/* comment this part for now */}
            {/* <div className="d-flex">
              {location == "/business-message" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-message"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-message"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-message" ? (
                    <img
                      src={MessageImg}
                      alt="MessageImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Message}
                      alt={"Message"}
                      className={"img_slider_false"}
                    />
                  )}
                  پیام‌ها
                </MDBListGroupItem>
              </Link>
            </div> */}
            <div className="d-flex">
              {location == "/business-images" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-images"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-images"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-images" ? (
                    <img
                      src={AddPicImg}
                      alt="AddPicImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={AddPic}
                      alt={"AddPic"}
                      className={"img_slider_false"}
                    />
                  )}
                  گالری عکس
                </MDBListGroupItem>
              </Link>
            </div>
            {/* comment this part for now */}
            {/* <div className="d-flex">
              {location == "/business-report" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-report"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-report"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-report" ? (
                    <img
                      src={AmarImg}
                      alt="AmarImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Amar}
                      alt={"Amar"}
                      className={"img_slider_false"}
                    />
                  )}
                  آمار و گزارش
                </MDBListGroupItem>
              </Link>
            </div> */}
            <div className="d-flex">
              {location == "/business-ads" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-ads"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-ads"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-ads" ? (
                    <img
                      src={TablighatImg}
                      alt="TablighatImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Tablighat}
                      alt={"Tablighat"}
                      className={"img_slider_false"}
                    />
                  )}
                  تبلیغات
                </MDBListGroupItem>
              </Link>
            </div>
            {/* setting */}
            <div className="d-flex mt_exit_business">
              {location == "/business-setting" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-setting"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-setting"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-setting" ? (
                    <img
                      src={SettingImg}
                      alt="LogoutImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Setting}
                      alt={"Logout"}
                      className={"img_slider_false"}
                    />
                  )}
                  تنظیمات
                </MDBListGroupItem>
              </Link>
            </div>
            {/* exit */}
            <div className="d-flex">
              {location == "/business-exit" && (
                <div className="active_item_business"></div>
              )}
              <Link className="dash-bus-sidbar-link" to={"/business-exit"}>
                <MDBListGroupItem
                  noBorders
                  className={
                    location === "/business-exit"
                      ? "chooseitem_business"
                      : "click_business"
                  }
                >
                  {location === "/business-exit" ? (
                    <img
                      src={LogoutImg}
                      alt="LogoutImg"
                      className={"img_slider_true"}
                    />
                  ) : (
                    <img
                      src={Logout}
                      alt={"Logout"}
                      className={"img_slider_false"}
                    />
                  )}
                  خروج
                </MDBListGroupItem>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <MDBModal tabIndex="-1" show={centredModal} setShow={setCentredModal}>
        <MDBModalDialog centered>
          <MDBModalContent className={"modal_delete_img height-fit"}>
            <MDBModalHeader className="modal-delete-img-header">
              <MDBModalTitle></MDBModalTitle>
              <MDBBtn
                className="btn-close button_delete_modal_img"
                color="none"
                onClick={toggleShow}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <div>
                <p
                  className={"text_modal_delete_img text_modal_delete_img_pre"}
                >
                  {/* برای ثبت کسب‌و‌کارهای بیشتر نیاز به خرید اشتراک پریمیوم دارید! */}
                  در حال حاضر فقط امکان ثبت 4 کسب‌و‌کار وجود دارد. به زودی و در
                  نسخه جدید امکان ثبت کسب‌و‌کارهای بیشتر مهیا می شود.
                </p>
              </div>
              <div className="a_s_c d-flex justify-content-center">
                <button
                  // onClick={props.api ? handleInputChangeApi : handleInputChange}
                  onClick={toggleShow}
                  className="button_modal_delete_img mt-0"
                >
                  تایید
                </button>
              </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
};

export default Sidbar;
